import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/70935
const trackGroupCardClick = (
  groupName: string,
  isPersonalView: boolean,
  source: SCREEN_NAME = SCREEN_NAME.PROFILE,
) => {
  sendUIEvent({
    source,
    action: 'clicked',
    actionSubject: 'card',
    actionSubjectId: 'groupCard',
    attributes: {
      groupName: groupName ?? 'not-named',
    },
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71737
const trackJoinGroupClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'findAGroup',
    source: SCREEN_NAME.PROFILE,
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71746
const trackGroupsBackToProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.GROUPS,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'backToProfile',
    isPersonalView,
  });
};

export {
  trackGroupCardClick,
  trackJoinGroupClick,
  trackGroupsBackToProfileClick,
};
